// Animated avatar — white background with copper radar pulse + scanline + breathing.
// Source canonical: design-system/project/homepage/index.html § Portrait component.

type Props = {
  src?: string;
  name?: string;
  size?: number;
};

export default function Portrait({ src, name = '', size = 120 }: Props) {
  const initials = name.split(' ').map(s => s[0] || '').slice(0, 2).join('').toUpperCase();
  return (
    <div
      className="portrait-shell"
      style={{
        width: size, height: size, borderRadius: '50%',
        overflow: 'hidden', flexShrink: 0,
        background: '#FFFFFF',
        position: 'relative',
      }}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          loading="lazy"
          className="portrait-img"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
      ) : (
        <div
          style={{
            position: 'absolute', inset: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'Inter Tight, system-ui, sans-serif',
            fontSize: Math.round(size * 0.32),
            fontWeight: 600,
            color: '#78716C',
            letterSpacing: '-0.02em',
          }}
        >
          {initials}
        </div>
      )}
    </div>
  );
}
